<template>
<div class="container">

	<div class="alert alert-success text-center">
		<h2>You're ready to roll!</h2>

		<p>You're all set up and ready to start using Tradetraks free time tracking features. You can get started by going to the <router-link to="/projects">Projects</router-link> and create a project to start clocking into.</p>

		<router-link to="/projects" class="btn btn-primary">Go to Projects</router-link>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "FreeTierSuccess"
}
</script>